'use strict';
const angular = require('angular');

/*@ngInject*/
export function RecurringPaymentsService($resource) {
  return $resource('/api/recurring-payments/:id', {
    name: '@_id'
  },{
    getByUser: {
      method: 'GET',
      url: "/api/recurring-payments/user/:id",
      isArray: true
    },
    update: {
      method: 'PUT'
    }
  });
}


export default angular.module('conduuApp.RecurringPaymentsService', [])
  .factory('RecurringPaymentsService', RecurringPaymentsService)
  .name;



// WEBPACK FOOTER //
// ./client/services/recurring-payments/recurring-payments.service.js